import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const getList = (date) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "post",
    url: baseUrl + "/projects/" + projectId + "/reports/events",
    needToken: true,
    params: {
      date
    }
  });
};
